// extracted by mini-css-extract-plugin
module.exports = {"container":"background-module--container--HqGHJ","static":"background-module--static--3ZsRi","blurredParticles":"background-module--blurred-particles--3la4x"};